// let DevMode = true;
let DevMode = false;
const LOCALHOST = "http://localhost:3500";
const RENDER = "https://backend-testing-portal-us.onrender.com";


let USER_API, ADMIN_API, RESOURCES_API;

if (DevMode) {
    USER_API = LOCALHOST + '/api';
    ADMIN_API = LOCALHOST + '/Admin';
    RESOURCES_API = LOCALHOST + '/';
} else {
    USER_API = RENDER + '/api';
    ADMIN_API = RENDER + '/Admin';
    RESOURCES_API = RENDER + '/';
    // RESOURCES_API = LOCALHOST + '/';
    // ADMIN_API = LOCALHOST + '/Admin';
    // USER_API = LOCALHOST + '/api';
}


const TestTypes = () => {
    return ([
        {
            id: 0,
            name: 'Select the Test Type'
        },
        {
            id: 1,
            name: 'Delayed Result Test'
        },
        {
            id: 2,
            name: 'Immediate Result Test'
        },
    ])
}

const ClassOptions = () => {
    return [
        {
            id: 0,
            name: 'Select the Class'
        },
        {
            id: 1,
            name: '9th'
        },
        {
            id: 2,
            name: '10th'
        },
        {
            id: 3,
            name: '11th Engineering'
        },
        {
            id: 4,
            name: '11th Medical'
        },
        {
            id: 5,
            name: '12th Engineering'
        },
        {
            id: 6,
            name: '12th Medical'
        },
        {
            id: 7,
            name: 'Engineering Drop'
        },
        {
            id: 8,
            name: 'Medical Drop'
        },
    ]
}

const extractScholarship = (score, TestAttempted) => {
    let marksGot = score;
    let totalMarks = TestAttempted.actualAnswers.length * 4;
    totalMarks = parseInt(totalMarks);

    if (marksGot >= totalMarks * 0.9) {
        return '100%';
    }
    else if (marksGot >= totalMarks * 0.75) {
        return '75%';
    }
    else if (marksGot >= totalMarks * 0.5) {
        return '50%';
    }
    else if (marksGot >= totalMarks * 0.4) {
        return '25%';
    }
    else {
        return '10%';
    }
}
/*
status-0,->unseen
status-1,->unattempted
status-2,->attempted
status-3,->mark for review
*/



module.exports = {
    USER_API,
    ADMIN_API,
    DevMode,
    ClassOptions,
    TestTypes,
    extractScholarship,
    RESOURCES_API
}